import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";
import routes from "./routes";

const router = createRouter({
    history: process.env.NODE_ENV !== "production" ? createWebHashHistory() : createWebHistory(),
    routes,
});

export default router;
